module.exports = __webpack_public_path__ + "img/other.058a2cfb.svg";